import React from "react";
import siteConfig from "../Datas/siteConfig";
import "../css/delivery.scss";

const sections = [
  ["What cookies are", "Cookies are small text files stored by a browser. Similar local-storage technologies may remember settings or keep a shopping session working."],
  ["Strictly necessary storage", "We use essential storage for the shopping bag, wishlist, security, load balancing and checkout continuity. These functions cannot be switched off through the store without affecting service."],
  ["Analytics and preference tools", "If optional analytics or preference tools are introduced, they will be used only where permitted and, when required, after you make a choice."],
  ["Payment and third parties", "Our payment provider may set strictly necessary security and fraud-prevention cookies when you continue to its payment environment. Its own notice explains those tools."],
  ["Managing cookies", "You can remove or block cookies in your browser settings. Blocking essential storage may empty your bag, forget preferences or prevent checkout from completing."],
  ["Updates and questions", `We may update this notice as store technology changes. Questions can be sent to ${siteConfig.contact.customerServiceEmail}.`],
];

export default function Cookies() {
  return (
    <main className="policy-page" id="main-content">
      <header className="policy-page__header">
        <p className="policy-page__eyebrow">Legal</p><h1>Cookie policy</h1>
        <p>How browser storage supports the Reamflora shopping experience.</p>
        <p className="policy-page__updated">Last updated <time dateTime="2026-09-30">30 September 2026</time></p>
      </header>
      <article className="policy-page__content" style={{ maxWidth: 980, margin: "0 auto" }}>
        {sections.map(([title, body], index) => (
          <section key={title}>
            <span className="policy-page__number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
            <div><h2>{title}</h2><p>{body}</p></div>
          </section>
        ))}
      </article>
    </main>
  );
}
